import { FileErrors } from '@verify/shared-utils';

export const supportedFileTypes = {
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc', '.docx'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.doc', '.docx'],
  'application/vnd.ms-excel': ['.xls', '.xlsx'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xls', '.xlsx'],
  'application/vnd.ms-powerpoint': ['.ppt', '.pptx'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.ppt', '.pptx'],
  'application/xml': ['.xml'],
  'application/postscript': ['.ai'],
  'application/vnd.adobe.illustrator': ['.ai'],
  'application/illustrator': ['.ai'],
  'application/rtf': ['.rtf'],
  'image/png': ['.png'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/tiff': ['.tiff', '.tif'],
  'application/html': ['.html'],
  'application/zip': ['.zip'],
  'text/csv': ['.csv'],
  'application/x-len': ['.len'],
  'application/x-lenx': ['.lenx'],
};

export const lowerCaseExtension = (name: string) => {
  const fileNameParts = name.split('.');
  const extension = fileNameParts.pop() || '';
  fileNameParts.push(extension.toLowerCase());
  return fileNameParts.join('.');
};

export const getFileErrorMessage = (errorType?: FileErrors): string => {
  switch (errorType) {
    case FileErrors.IncompatibleZipFile:
      return 'The file you uploaded is not a valid Structured Product Labeling (SPL) zip file. Please check your file and try again.';
    case FileErrors.AiNonCompatible:
      return 'There was an error uploading your Illustrator file. Verify that your file was saved using compatibility mode and please try again.';
    default:
      return 'There was an error uploading your file. Please try again.';
  }
};
